import { Guid, Nillable } from '@web/utils';
import { jsonMember, jsonObject } from 'typedjson';
import { WarehouseRestockContextOperationsResponse } from './warehouse-restock-context-operations.response';
import { WarehouseRestockStatus } from '../../enums/warehouse-restock-status';
import { WarehouseRestockType } from '../../enums/warehouse-restock-type';
import { WarehouseRestockPersonResponse } from './warehouse-restock-person.response';
import { WarehouseRestockOrderResponse } from './warehouse-restock-order.response';

@jsonObject
export class WarehouseRestockCollectionItemResponse {
  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(Date)
  public readonly restockedAt!: Date;

  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly number!: string;

  @jsonMember(String)
  public readonly shippingNumber?: Nillable<string>;

  @jsonMember(String)
  public readonly status!: WarehouseRestockStatus;

  @jsonMember(String)
  public readonly type!: WarehouseRestockType;

  @jsonMember(WarehouseRestockOrderResponse)
  public readonly order?: Nillable<WarehouseRestockOrderResponse>;

  @jsonMember(WarehouseRestockContextOperationsResponse)
  public readonly contextOperations!: WarehouseRestockContextOperationsResponse;

  @jsonMember(WarehouseRestockPersonResponse)
  public readonly person?: Nillable<WarehouseRestockPersonResponse>;
}
